<cec-dialog
  #dialog
  [headerText]="(id ? 'Edit registration' : 'Sign crew to the competition') | translate"
  [subTitle]="competitionName"
  [formGroup]="formGroup"
  [disableConfirmButton]="formGroup.invalid || formGroup.controls['driverId'].disabled"
  (onButtonClicked)="onClickButton($event)"
>
  <form [formGroup]="formGroup">
    <div class="row">
      <cec-select labelKey="Crew number" [options]="crews" formControlName="crewId"></cec-select>
      <cec-date-range-picker labelKey="Date range for competition" formControlName="accommodationDuration"></cec-date-range-picker>
    </div>
    <div class="row">
      <cec-select labelKey="Driver" [options]="competitors | competitor:formGroup:'driverId':updated" formControlName="driverId"></cec-select>
      <cec-select labelKey="Navigator" [options]="competitors | competitor:formGroup:'navigatorId':updated" formControlName="navigatorId"></cec-select>
    </div>
    <div class="row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'Competitor note' | translate }}</mat-label>
        <textarea matInput formControlName="noteCompetitor"></textarea>
      </mat-form-field>
    </div>
    <div class="row">
      <cec-item-list-selector 
        labelKey="Additional Competitors"
        [options]="competitors | competitor:formGroup:'additionalCompetitors':updated" 
        formControlName="additionalCompetitors"></cec-item-list-selector>
    </div>
  </form>
</cec-dialog>